import React from "react";
import { PAYMENT_METHODS } from "../../lib/data";
import { ShieldCheck, Globe2 } from "lucide-react";
import { useI18n } from "../../i18n/I18nProvider";

export default function PaymentMethods() {
  const { t } = useI18n();
  return (
    <section data-testid="payment-methods-section" className="py-24 sm:py-32 bg-white">
      <div className="container-oj">
        <div className="grid grid-cols-1 md:grid-cols-12 gap-8 mb-12 items-end">
          <div className="md:col-span-7">
            <div className="text-xs font-bold uppercase tracking-[0.25em] text-zinc-500">{t("payments_section.eyebrow")}</div>
            <h2 className="font-display mt-3 text-balance text-4xl sm:text-5xl lg:text-6xl font-black tracking-tighter leading-[0.95] text-oj-ink">
              {t("payments_section.h2")}
            </h2>
          </div>
          <div className="md:col-span-5 text-zinc-600 max-w-md">
            {t("payments_section.body_a")}{" "}
            <a href="https://swisspayout.com" target="_blank" rel="noreferrer" className="font-semibold text-oj-ink underline underline-offset-4 decoration-2 decoration-oj-payment hover:decoration-4">
              Swisspayout
            </a>
            {t("payments_section.body_b")}
          </div>
        </div>

        <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-6 border-l border-t border-zinc-200" data-testid="payment-methods-grid">
          {PAYMENT_METHODS.map((m) => (
            <div
              key={m.id}
              data-testid={`payment-${m.id}`}
              className="aspect-[4/3] flex flex-col items-center justify-center gap-2 border-r border-b border-zinc-200 px-4 hover:bg-zinc-50 transition-colors group"
            >
              <span className="h-1.5 w-10 rounded-full" style={{ background: m.color }} />
              <span className="font-display text-base sm:text-lg font-bold tracking-tight text-zinc-800 group-hover:text-oj-ink text-center">
                {m.name}
              </span>
              {m.note && <span className="font-mono text-[10px] uppercase tracking-[0.2em] text-zinc-500">{m.note}</span>}
            </div>
          ))}
        </div>

        <div className="mt-10 grid grid-cols-1 md:grid-cols-3 gap-5">
          <div className="rounded-2xl border border-zinc-200 p-6 bg-zinc-50">
            <div className="flex items-center gap-2">
              <Globe2 className="size-4 text-oj-payment" />
              <span className="font-mono text-[11px] uppercase tracking-[0.25em] text-zinc-500">{t("payments_section.coverage")}</span>
            </div>
            <div className="mt-3 font-display text-xl font-bold text-oj-ink leading-tight">
              {t("payments_section.coverage_title")}
            </div>
            <p className="mt-2 text-sm text-zinc-600">{t("payments_section.coverage_body")}</p>
          </div>
          <div className="rounded-2xl border border-zinc-200 p-6 bg-zinc-50">
            <div className="flex items-center gap-2">
              <ShieldCheck className="size-4 text-oj-payment" />
              <span className="font-mono text-[11px] uppercase tracking-[0.25em] text-zinc-500">{t("payments_section.compliance")}</span>
            </div>
            <div className="mt-3 font-display text-xl font-bold text-oj-ink leading-tight">
              {t("payments_section.compliance_title")}
            </div>
            <p className="mt-2 text-sm text-zinc-600">{t("payments_section.compliance_body")}</p>
          </div>
          <div className="rounded-2xl border border-zinc-200 p-6 bg-zinc-50">
            <div className="flex items-center gap-2">
              <span className="h-3 w-3 rounded-full bg-oj-payment" />
              <span className="font-mono text-[11px] uppercase tracking-[0.25em] text-zinc-500">{t("payments_section.ch_first")}</span>
            </div>
            <div className="mt-3 font-display text-xl font-bold text-oj-ink leading-tight">
              {t("payments_section.ch_first_title")}
            </div>
            <p className="mt-2 text-sm text-zinc-600">{t("payments_section.ch_first_body")}</p>
          </div>
        </div>
      </div>
    </section>
  );
}
